module.exports = __webpack_public_path__ + "img/eleven_forty.c721918a.svg";